import ResponsiveSidebar from "../../General/ResponsiveSidebar/ResponsiveSidebar";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  SupportAgent as TicketsIcon,
  AddCircleOutline as AddIcon,
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";

const drawerWidth = 240;
const collapsedWidth = 60;

interface TicketsSidebarProps {
  open?: boolean;
  toggle?: () => void;
}

const TicketsSidebar = ({
  open = false,
  toggle = () => {},
}: TicketsSidebarProps) => {
  const location = useLocation();
  const menuItems = [
    { text: "All Tickets", icon: <TicketsIcon />, path: "/tickets" },
    { text: "Create Ticket", icon: <AddIcon />, path: "/tickets/new" },
  ];

  return (
    <ResponsiveSidebar
      open={open}
      onClose={toggle}
      sx={(theme) => ({
        width: open ? drawerWidth : collapsedWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? drawerWidth : collapsedWidth,
          boxSizing: "border-box",
          top: 64,
          height: "calc(100% - 64px)",
          overflowX: "hidden",
          position: "fixed",
          transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.standard,
          }),
        },
      })}
    >
      <Toolbar sx={{ justifyContent: open ? "flex-end" : "center" }}>
        <IconButton
          onClick={toggle}
          aria-label={
            open ? "Close section navigation" : "Open section navigation"
          }
        >
          {open ? <ChevronLeftIcon /> : <MenuIcon />}
        </IconButton>
      </Toolbar>
      <List>
        {menuItems.map((item) => {
          const selected =
            item.path === "/tickets"
              ? location.pathname === item.path
              : location.pathname.startsWith(item.path);
          const button = (
            <ListItemButton
              key={item.text}
              selected={selected}
              component={RouterLink}
              to={item.path}
              sx={{ justifyContent: open ? "initial" : "center" }}
            >
              <ListItemIcon
                sx={{ minWidth: 0, mr: open ? 3 : 0, justifyContent: "center" }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          );
          return open ? (
            button
          ) : (
            <Tooltip key={item.text} title={item.text} placement="right">
              {button}
            </Tooltip>
          );
        })}
      </List>
    </ResponsiveSidebar>
  );
};

export default TicketsSidebar;
